module.exports = __webpack_public_path__ + "static/media/course-bg.a1dd7fc2.jpg";